<template>
  <v-dialog v-model="visible" width="1000" lazy persistent>
    <v-card>
      <v-card-title>
        <span class="headline">Personal Accident Post Mapping</span>
      </v-card-title>
      <v-card-text>
        <message :messages="messages"></message>
          <v-container grid-list-md >
            <v-layout wrap>
              <v-flex xs4 v-if="!newMapping">
                <v-subheader class="queryLabel">{{labels.scheme}}</v-subheader>
                <div>{{scheme}}</div>
              </v-flex>
              <v-flex xs4 v-else>
                <v-autocomplete :items="postMapParams.schemes" v-model="postMapForm.scheme" :label="labels.scheme" item-text="label" item-value="value" data-vv-name="scheme" :data-vv-as="labels.scheme" :error-messages="errors.collect('scheme')" v-validate="'required'" @input="doScheme"></v-autocomplete>
              </v-flex>
              <v-flex xs4 v-if="!newMapping">
                <v-subheader class="queryLabel">{{labels.planNo}}</v-subheader>
                <div>{{plan}}</div>
              </v-flex>
              <v-flex xs4 v-else>
                <v-autocomplete :items="postMapParams.plans" v-model="postMapForm.planNo" :label="labels.planNo" item-text="label" item-value="value" data-vv-name="planNo" :data-vv-as="labels.planNo" :error-messages="errors.collect('planNo')" v-validate="'required'"></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-divider></v-divider>
                <v-flex xs12></v-flex>
                <v-layout row wrap justify-center align-center>
                  <span class="title pb-3">
                    Mapped to
                  </span>
                </v-layout>
                <v-layout row wrap justify-center align-center>
                  <span>
                    <v-icon large>mdi-arrow-down-bold</v-icon>
                  </span>
                </v-layout>
                <v-flex xs12></v-flex>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs6>
                <v-text-field :label="labels.schemeMap" v-model="postMapForm.schemeMap" :error-messages="errors.collect('schemeMap')" data-vv-name="schemeMap" :data-vv-as="labels.schemeMap" v-validate="'required|entry|max:4'"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field :label="labels.planNoMap" v-model="postMapForm.planNoMap" :error-messages="errors.collect('planNoMap')" data-vv-name="planNoMap" :data-vv-as="labels.planNoMap" v-validate="'required|entry|max:4'"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click.native="doCancel">Cancel</v-btn>
        <v-btn color="primary" flat :loading="submitting" @click.prevent="doSave">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { extractMenu, extractLabel } from '@/utils/extract'

export default {
  data() {
    return {
      labels: {
        scheme: 'Scheme',
        planNo: 'Plan',
        schemeMap: 'Mapped Scheme',
        planNoMap: 'Mapped Plan'
      },
      postMapForm: {
        scheme: undefined,
        planNo: undefined,
        schemeMap: undefined,
        planNoMap: undefined,
        revision: undefined
      },
      visible: false,
      newMapping: false,
      submitting: false,
      menu: [],
      postMapParams: {
        schemes: [],
        plans: []
      },
      planNoLoading: false
    }
  },
  watch: {
    'newMap': function (newMap) {
      this.newMapping = newMap
    },
    'value': function (value) {
      this.visible = value
    },
    'visible': function (value) {
      if (!value) {
        // As this components using v-model to pass in value,
        // we have to emit back the value
        this.$emit('input', false)
      } else {
        // init here
        this.doInit()
      }
    }
  },
  computed: {
    postingState() {
      return this.$store.state.agency.posting
    },
    scheme() {
      return extractLabel(this.postMapParams.schemes, this.postMapForm.scheme)
    },
    plan() {
      return extractLabel(this.postMapParams.plans, this.postMapForm.planNo)
    }
  },
  methods: {
    async doInit() {
      this.resetMessages()
      this.postMapForm.scheme = undefined
      this.postMapForm.planNo = undefined
      this.postMapForm.schemeMap = undefined
      this.postMapForm.planNoMap = undefined
      this.postMapForm.revision = undefined
      this.postMapParams.schemes = this.params.schemes
      if (!this.newMapping) {
        // Review
        await this.getPostMap()
        await this.getPlans()
      } else {
        this.postMapParams.plans = []
      }
    },
    async getPostMap() {
      if (this.postMapId.scheme && this.postMapId.planNo && this.postMapId.paArea) {
        const apiURI = this.postingState.menu.paPostMapGet
        if (apiURI) {
          try {
            const expand = {
              scheme: this.postMapId.scheme,
              planNo: this.postMapId.planNo
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.postMapForm.scheme = data.postMap.scheme
              this.postMapForm.planNo = data.postMap.planNo
              this.postMapForm.schemeMap = data.postMap.schemeMap
              this.postMapForm.planNoMap = data.postMap.planNoMap
              this.postMapForm.revision = data.postMap.revision
              // Extract menu
              this.menu = extractMenu(result.data._links)
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
          }
        } else {
          this.$snotify.error('Invalid API URL')
        }
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newMapping) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.postingState.menu.paPostMapCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.postMapForm)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async doUpdate() {
      const apiURI = this.menu.paPostMapUpdate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.postMapForm)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doCancel() {
      this.doInit()
      this.$emit('close')
    },
    doScheme() {
      if (this.postMapForm.scheme) {
        this.getPlans()
      } else {
        this.postMapForm.planNo = undefined
        this.getPlans()
      }
    },
    async getPlans() {
      const apiURI = this.postingState.menu.paPostMapPlans
      if (apiURI) {
        try {
          this.planNoLoading = true
          const expand = {
            scheme: this.postMapForm.scheme
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            this.postMapParams.plans = result.data.data
          }
          this.planNoLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.planNoLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    }
  },
  mixins: [
    MessageMixin
  ],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    newMap: {
      type: Boolean,
      default: false
    },
    postMapId: {
      type: Object,
      default: () => { }
    },
    params: {
      type: Object,
      default: () => { }
    }
  }
}
</script>

<style>

</style>
